import { Signal } from "@angular/core";
import { SyncStoreSaveData } from "../../storage/sync-store/update-data/sync-store-save-data";
import { SyncStoreUpdateBatchWeighing } from "../../storage/sync-store/update-data/sync-store-update-batch-weighing";
import { addAllObjectsToStore } from "../store-add-all-objects.function";


export function persistBatchWeighings(
  newData: SyncStoreSaveData<SyncStoreUpdateBatchWeighing>,
  dataFromStore: Signal<SyncStoreSaveData<SyncStoreUpdateBatchWeighing>[]>
) {
  const allUpdateWeighings = addAllObjectsToStore([newData], dataFromStore());
  const retStateSlice = {
    batchWeighings: allUpdateWeighings as SyncStoreSaveData<SyncStoreUpdateBatchWeighing>[],
  };
  return retStateSlice;
}
